import { Button } from '../ui/Button';

/**
 * Run / Schedule / Export actions. These belong in the dashboard header (never
 * on Reports Center tiles). Handlers are optional; buttons are inert when absent.
 */
export function DashboardActions({ onRun, onSchedule, onExport }) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Button variant="gradient" onClick={onRun}>
        Run
      </Button>
      <Button variant="navy" onClick={onSchedule}>
        Schedule
      </Button>
      <Button variant="ghost" onClick={onExport}>
        Export
      </Button>
    </div>
  );
}

export function DashboardHeader({ title, subtitle, actions }) {
  return (
    <div className="flex flex-col gap-4 border-b border-eorig-border px-5 py-5 sm:flex-row sm:items-start sm:justify-between sm:px-6 sm:py-6">
      <div className="min-w-0">
        <h2 className="text-lg font-semibold tracking-tight text-eorig-ink sm:text-xl">
          {title}
        </h2>
        {subtitle ? (
          <p className="mt-1.5 max-w-2xl text-xs leading-relaxed text-eorig-muted sm:text-sm">
            {subtitle}
          </p>
        ) : null}
      </div>
      {actions ?? null}
    </div>
  );
}
